var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPaperclipBlue(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.59792 14.8393L13.1736 8.54495C13.9631 7.78923 13.9631 6.56397 13.1736 5.80825C12.3842 5.05253 11.1041 5.05253 10.3146 5.80825L3.78656 12.057C2.28652 13.4929 2.28652 15.8209 3.78656 17.2568C5.2866 18.6926 7.71864 18.6926 9.21868 17.2568L15.8421 10.9167C18.0526 8.80074 18.0526 5.37001 15.8421 3.254C13.6315 1.13799 10.0474 1.13799 7.83682 3.254L2.5 8.3625",
    stroke: "#1F44DD",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPaperclipBlue);
export default __webpack_public_path__ + "static/media/Paperclip-blue.49d18af0154d24d5f20bcb8395888eb1.svg";
export { ForwardRef as ReactComponent };